<script>
import ImpressionModels from "@/views/Impression/Components/ImpressionModels.vue";
import useSharedData from "@/use/SharedData";
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";
import PaySlipFilter from "@/views/PaySlip/Components/PaySlipFilter.vue";

export default {
    components: {PaySlipFilter, ImpressionModels},
    setup: function () {
        const {$moment, $i18n} = useTools();
        const {loading, filter} = useSharedData();
        const {priceFormat} = useSharedMethod();
        const {transformFilterValues} = useSharedMethod();
        
        filter.value = {
            closed: null,
        };
        
        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
        }
        
        const agencyCaisses = ref([]);
        const paySlipCaisses = ref([]);
        
        const headersMois = [
            {
                text: $i18n.t('common.total'),
                align: "end",
                sortable: true,
                value: "totalMois"
            },
            {
                text: $i18n.t('common.JANUARY'),
                align: "end",
                sortable: true,
                value: "january"
            },
            {
                text: $i18n.t('common.FEBRUARY'),
                align: "end",
                sortable: true,
                value: "february"
            },
            {
                text: $i18n.t('common.MARCH'),
                align: "end",
                sortable: true,
                value: "march"
            },
            {
                text: $i18n.t('common.APRIL'),
                align: "end",
                sortable: true,
                value: "april"
            },
            {
                text: $i18n.t('common.MAY'),
                align: "end",
                sortable: true,
                value: "may"
            },
            {
                text: $i18n.t('common.JUNE'),
                align: "end",
                sortable: true,
                value: "june"
            },
            {
                text: $i18n.t('common.JULY'),
                align: "end",
                sortable: true,
                value: "july"
            },
            {
                text: $i18n.t('common.AUGUST'),
                align: "end",
                sortable: true,
                value: "august"
            },
            {
                text: $i18n.t('common.SEPTEMBER'),
                align: "end",
                sortable: true,
                value: "september"
            },
            {
                text: $i18n.t('common.OCTOBER'),
                align: "end",
                sortable: true,
                value: "october"
            },
            {
                text: $i18n.t('common.NOVEMBER'),
                align: "end",
                sortable: true,
                value: "november"
            },
            {
                text: $i18n.t('common.DECEMBER'),
                align: "end",
                sortable: true,
                value: "december"
            },
        ];
        
        const headersTrimestre = [
            {
                text: $i18n.t('common.total'),
                align: "end",
                sortable: true,
                value: "totalTrimestre"
            },
            {
                text: $i18n.t('common.QUARTERLY_1'),
                align: "end",
                sortable: true,
                value: "montantPremierTrimestre"
            },
            {
                text: $i18n.t('common.QUARTERLY_2'),
                align: "end",
                sortable: true,
                value: "montantDeuxiemeTrimestre"
            },
            {
                text: $i18n.t('common.QUARTERLY_3'),
                align: "end",
                sortable: true,
                value: "montantTroixiemeTrimestre"
            },
            {
                text: $i18n.t('common.QUARTERLY_4'),
                align: "end",
                sortable: true,
                value: "montantQuatriemeTrimestre"
            },
        ];
        
        const byTrimestre = ref(false);
        const agenceHeaders = ref([]);
        const paySlipHeaders = ref([]);
        
        const tab = ref(null);
        const cnasAgencyId = ref(null);
        const year = ref($moment().year() - 1);
        
        function verifier() {
            loading.value = true;
            axios.get('/printed/verificationCaisses', {
                params: transformFilterValues({
                    ...filter.value,
                    cnasAgencyId: cnasAgencyId.value,
                    year: year.value,
                    byTrimestre: byTrimestre.value,
                })
            }).then((response) => {
                
                if (byTrimestre.value) {
                    agenceHeaders.value = [
                        {text: $i18n.t('common.name'), align: "start", sortable: true, value: "prenom"},
                        ...headersTrimestre,
                    ];
                    
                    paySlipHeaders.value = [
                        {text: $i18n.t('worker.code'), align: "start", sortable: true, value: "matricule"},
                        {text: $i18n.t('common.last_name'), align: "start", sortable: true, value: "nom"},
                        {text: $i18n.t('common.first_name'), align: "start", sortable: true, value: "prenom"},
                        ...headersTrimestre,
                    ]
                } else {
                    agenceHeaders.value = [
                        {text: $i18n.t('common.name'), align: "start", sortable: true, value: "prenom"},
                        ...headersMois,
                    ];
                    
                    paySlipHeaders.value = [
                        {text: $i18n.t('worker.code'), align: "start", sortable: true, value: "matricule"},
                        {text: $i18n.t('common.last_name'), align: "start", sortable: true, value: "nom"},
                        {text: $i18n.t('common.first_name'), align: "start", sortable: true, value: "prenom"},
                        ...headersMois,
                    ]
                }
                
                agencyCaisses.value = response.data.agencyCaisses;
                paySlipCaisses.value = response.data.paySlipCaisses;
                
                let totalObject = {
                    isTotal: true,
                    prenom: $i18n.t('common.total_general'),
                    january: response.data.january,
                    february: response.data.february,
                    march: response.data.march,
                    april: response.data.april,
                    may: response.data.may,
                    june: response.data.june,
                    july: response.data.july,
                    august: response.data.august,
                    september: response.data.september,
                    october: response.data.october,
                    november: response.data.november,
                    december: response.data.december,
                    
                    montantPremierTrimestre: response.data.montantPremierTrimestre,
                    montantDeuxiemeTrimestre: response.data.montantDeuxiemeTrimestre,
                    montantTroixiemeTrimestre: response.data.montantTroixiemeTrimestre,
                    montantQuatriemeTrimestre: response.data.montantQuatriemeTrimestre,
                    
                    totalMois: response.data.totalMois,
                    totalTrimestre: response.data.totalTrimestre,
                };
                
                agencyCaisses.value.unshift(totalObject);
                paySlipCaisses.value.unshift(totalObject);
                
            }).finally(() => {
                loading.value = false;
            })
        }
        
        onMounted(() => verifier());
        
        return {
            loading,
            tab,
            filter,
            cnasAgencyId,
            year,
            byTrimestre,
            agenceHeaders,
            paySlipHeaders,
            agencyCaisses,
            paySlipCaisses,
            clearFilter,
            priceFormat,
            verifier,
        }
    }
}
</script>

<template>
    <w-app
        :title="$t('module.verification_caisses')"
        show-filter
        :filter="filter"
        @clearFilter="clearFilter"
    >
        <template v-slot:filter>
            <pay-slip-filter v-model="filter"/>
        </template>
        
        <template v-slot:rightToolbar>
            <impression-models/>
            <w-btn
                icon="mdi-check-all"
                color="teal"
                :text="$t('common.verify')"
                :loading="loading"
                @press="verifier"
            />
        </template>
        <template v-slot:content>
            <v-card>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <str-cnas-agcency-autocomplete
                                v-model="cnasAgencyId"
                                :label="$t('module.cnas_agency')"
                                not-clearable
                                set-default
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <w-text-field
                                v-model="year"
                                not-clearable
                                type="number"
                                :label="$t('common.year')"
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-checkbox
                                v-model="byTrimestre"
                                class="mt-1"
                                :label="$t('impression.list_by_quarter')"
                            />
                        </v-col>
                    </v-row>
                    <br/>
                    <v-tabs
                        v-show="!loading"
                        v-model="tab"
                    >
                        <v-tab>{{ $t('impression.report') }}</v-tab>
                        <v-tab>{{ $t('impression.cnas_cashierless_payments') }}</v-tab>
                    </v-tabs>
                    <w-data-table
                        :headers="tab === 0 ? agenceHeaders : paySlipHeaders"
                        :items="tab === 0 ? agencyCaisses : paySlipCaisses"
                        :loading="loading"
                        disable-pagination
                        fixed-header
                        height="700"
                    >
                        <template v-slot:[`item.matricule`]="{ item }">
                            <w-chip outlined :text="item.matricule"/>
                        </template>
                        <template v-slot:[`item.nom`]="{ item }">
                            <w-chip outlined :text="item.nom"/>
                        </template>
                        <template v-slot:[`item.prenom`]="{ item }">
                            <w-chip
                                :large="item.isTotal"
                                outlined
                                :text="item.prenom"
                            />
                        </template>
                        <template v-slot:[`item.totalMois`]="{ item }">
                            <w-inline-text bold clazz="red--text" :text="priceFormat(item.totalMois)"/>
                        </template>
                        <template v-slot:[`item.totalTrimestre`]="{ item }">
                            <w-inline-text bold clazz="red--text" :text="priceFormat(item.totalTrimestre)"/>
                        </template>
                        
                        <template v-slot:[`item.january`]="{ item }">
                            <w-inline-text :text="priceFormat(item.january)"/>
                        </template>
                        <template v-slot:[`item.february`]="{ item }">
                            <w-inline-text :text="priceFormat(item.february)"/>
                        </template>
                        <template v-slot:[`item.march`]="{ item }">
                            <w-inline-text :text="priceFormat(item.march)"/>
                        </template>
                        <template v-slot:[`item.april`]="{ item }">
                            <w-inline-text :text="priceFormat(item.april)"/>
                        </template>
                        <template v-slot:[`item.may`]="{ item }">
                            <w-inline-text :text="priceFormat(item.may)"/>
                        </template>
                        <template v-slot:[`item.june`]="{ item }">
                            <w-inline-text :text="priceFormat(item.june)"/>
                        </template>
                        <template v-slot:[`item.july`]="{ item }">
                            <w-inline-text :text="priceFormat(item.july)"/>
                        </template>
                        <template v-slot:[`item.august`]="{ item }">
                            <w-inline-text :text="priceFormat(item.august)"/>
                        </template>
                        <template v-slot:[`item.september`]="{ item }">
                            <w-inline-text :text="priceFormat(item.september)"/>
                        </template>
                        <template v-slot:[`item.october`]="{ item }">
                            <w-inline-text :text="priceFormat(item.october)"/>
                        </template>
                        <template v-slot:[`item.november`]="{ item }">
                            <w-inline-text :text="priceFormat(item.november)"/>
                        </template>
                        <template v-slot:[`item.december`]="{ item }">
                            <w-inline-text :text="priceFormat(item.december)"/>
                        </template>
                        
                        <template v-slot:[`item.montantPremierTrimestre`]="{ item }">
                            <w-inline-text :text="priceFormat(item.montantPremierTrimestre)"/>
                        </template>
                        <template v-slot:[`item.montantDeuxiemeTrimestre`]="{ item }">
                            <w-inline-text :text="priceFormat(item.montantDeuxiemeTrimestre)"/>
                        </template>
                        <template v-slot:[`item.montantTroixiemeTrimestre`]="{ item }">
                            <w-inline-text :text="priceFormat(item.montantTroixiemeTrimestre)"/>
                        </template>
                        <template v-slot:[`item.montantQuatriemeTrimestre`]="{ item }">
                            <w-inline-text :text="priceFormat(item.montantQuatriemeTrimestre)"/>
                        </template>
                    </w-data-table>
                </v-container>
            </v-card>
        </template>
    </w-app>
</template>

<style scoped>

</style>